<template>
  <div id="about">
    <h2>درباره</h2>
    <!-- <hr /> -->
    <p>
      {{ info.about}}
    </p>
    <hr />
    <h2>اطلاعات شخصی</h2>
    <div id="about-info">
      <div class="row">
        <span>سن : </span>
        <span>{{ getAge(info.birthday)}}</span>
      </div>
      <div class="row">
        <span>شماره : </span>
        <span>{{ info.phone }}</span>
      </div>
      <div class="row">
        <span>ایمیل : </span>
        <span>{{ info.email }}</span>
      </div>
      <div class="row">
        <span>محل سکونت : </span>
        <span>{{ info.address }}</span>
      </div>
    </div>
  </div>
 
</template>

<script>
import axios from "axios";

export default {
  beforeCreate: function () {
    document.body.className = "about";
  },
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    axios
      .post("https://mohammadrostamidevapi.iran.liara.run/api/v1/about", {})
      .then((respose) => (this.info = respose.data))
      .then((error) => console.log(error));
    // console.log(this.info)
  },
  methods: {
    getAge(dateString) {
      var ageInMilliseconds = new Date() - new Date(dateString);
      return Math.floor(ageInMilliseconds / 1000 / 60 / 60 / 24 / 365); // convert to years
    },
  },
};
</script>

<style></style>
